import { useEffect, useState } from 'react'

/**
 * trailing debounce on a value. emits the latest value once `delay` ms
 * have passed without change. typical use: gate a server-side search
 * query on a debounced input so keystrokes don't fire a request each.
 */
export function useDebouncedValue<T>(value: T, delay = 200): T {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delay)
    return () => clearTimeout(handle)
  }, [value, delay])

  return debounced
}
